<template>

  <v-dialog v-model="cartDialog" hide-overlay scrollable persistent>
    <v-card class="dialog-safe">
      <!-- Botón de cerrar -->

      <v-card-title class="headline text-white" style="
          padding: 16px;
          background-color: #ee8625;
          background-image: url('https://mvexpress.mx/images/logosapp/logomv1.png');
          background-size: 160px auto; /* Ajusta tamaño del logo */
          background-position: left center; /* Logo anclado a la izquierda */
          background-repeat: no-repeat;
          display: flex;
          justify-content: space-between; /* 🔹 Logo izquierda / Botón derecha */
          align-items: center;
        ">
        <!-- Contenedor vacío solo para que el botón quede a la derecha -->
        <div style="width: 140px"></div>

        <!-- Botón de cerrar a la derecha -->
        <v-btn @click="$emit('update:modelValue', false)" color="red" class="text-white p-2" rounded>
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <!-- Alerta si el carrito está vacío -->
        <v-alert v-if="cart.length === 0" color="#0e4582" prominent border="start" elevation="1">
          <div class="d-flex align-center">
            <img
              src="https://cdn.shopify.com/s/files/1/1061/1924/products/Emoji_Icon_-_Sad_Emoji_grande.png?v=1571606093"
              alt="Sad emoji" style="width: 40px; height: 40px; margin-right: 12px" />
            <div>
              <strong>¡Tu carrito está vacío!</strong> Agrega productos para comenzar tu
              compra
            </div>
          </div>
        </v-alert>

        <!-- Código de descuento con Tailwind CSS 
<div class="mb-4 flex flex-col md:flex-row gap-3">
  <div class="flex-1">
    <label for="discountCode" class="block text-sm font-medium text-gray-700 mb-1">
      Código de descuento
    </label>
    <input
      id="discountCode"
      v-model="discountCode"
      type="text"
      placeholder="Introduce tu código de descuento"
      class="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>
  <div class="md:w-1/3 flex items-end">
    <button
      @click="applyDiscount"
      class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-150"
    >
      Aplicar
    </button>
  </div>
</div>
-->

        <!-- Lista de productos -->

        <div v-if="cart.length > 0">
          <v-container class="pa-0">
            <v-row v-for="(item, index) in cart" :key="item.id || item.sku || index" class="swipe-container"
              @touchstart="startTouch($event, index)" @touchmove="moveTouch($event, index)"
              @touchend="endTouch($event, index)">
              <!-- Botón rojo de eliminar -->
              <v-btn class="delete-btn" variant="flat" color="white" @click="handleRemove(item)" rounded="0">
                <v-icon color="red" size="26">mdi-delete</v-icon>
              </v-btn>

              <!-- Contenedor principal del producto -->
              <v-card class="swipe-content" elevation="2" :style="{
                transform: `translateX(${swipeState[index] || 0}px)`,
                transition: isSwiping ? 'none' : 'transform 0.25s ease-out',
              }">
                <!-- Alinea los elementos arriba -->
                <v-row no-gutters class="d-flex align-start">
                  <!-- Imagen -->
                  <v-col cols="3" class="d-flex justify-center" style="align-self: flex-start">
                    <div class="d-flex justify-center align-center bg-white  rounded-lg"
                      style="width: 85px; height: 85px; overflow: hidden">
                      <v-img :src="item.foto" alt="Imagen del producto" class="rounded" contain width="100%"
                        height="100%"></v-img>
                    </div>
                  </v-col>

                  <!-- Info del producto -->
                  <v-col cols="9" class="pa-2 d-flex flex-column justify-space-between" style="min-height: 100px">
                    <!-- Texto del producto -->
                    <div style="flex: 1 1 auto">
                      <div class="product-name text-body-2 font-weight-medium"
                        style="white-space: normal; word-break: break-word">
                        {{ item.nombre }}
                      </div>
                      <div class="text-caption text-gray-500 mb-1">
                        SKU: {{ item.sku }}
                      </div>

                      <!-- Precios -->
                      <template v-if="item.id_promocion && item.promo_price">
                        <p class="text-gray-500 text-caption line-through mb-0">
                          ${{ parseFloat(item.price).toFixed(2) }}
                        </p>
                        <p class="text-red text-body-1 font-weight-bold mb-0">
                          ${{
                            (item.price - (item.price * item.promo_price) / 100).toFixed(
                              2
                            )
                          }}
                        </p>
                        <p class="text-caption text-green-800 mt-1">
                          ¡{{ item.promo_price }}% de descuento!
                        </p>
                      </template>

                      <template v-else-if="
                        item.precio_con_descuento &&
                        item.precio_con_descuento < item.precio_desc
                      ">
                        <p class="text-gray-500 text-caption line-through mb-0">
                          ${{ item.precio_desc }}
                        </p>
                        <p class="text-green-600 text-body-1 font-weight-bold mb-0">
                          ${{ item.precio_con_descuento }}
                        </p>
                        <p class="text-orange-500 text-caption mt-1">¡Promoción!</p>
                      </template>

                      <template v-else>
                        <p class="text-blue-600 text-body-1 font-weight-bold mb-0">
                          ${{
                            item.precio_con_descuento || item.precio_desc || item.price
                          }}
                        </p>
                      </template>
                    </div>

                    <!-- Controles -->
                    <div class="d-flex justify-end align-center" style="flex-shrink: 0; margin-top: -60px">
                      <v-btn icon density="compact" color="orange-darken-1" @click="decreaseQuantity(item)"
                        :disabled="item.quantity <= 1">
                        <v-icon size="18">mdi-minus</v-icon>
                      </v-btn>

                      <span class="px-2 text-caption font-weight-bold">
                        CJA {{ item.quantity }}
                      </span>

                      <v-btn icon density="compact" color="blue-darken-4" @click="increaseQuantity(item)"
                        :disabled="(item.id_promocion && item.quantity >= 5) || (item.quantity >= item.yfr_disponible)">

                        <v-icon size="18">mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
            <br>
            <v-btn @click="checkout" class="wave-button text-none mt-2 d-flex flex-col align-center justify-center"
              color="green darken-2" rounded="lg" variant="flat"
              style="width: 100%; max-width: 300px; padding: 16px; position: relative; overflow: hidden;">
              <!-- Total arriba -->
              <span class="font-weight-bold text-center"
                style="color: white; font-size: 1.4rem; display: block; width: 100%;">
                Pagar: ${{ calculateTotal() }} MXN
              </span>

              <!-- Texto debajo más pequeño -->

            </v-btn>



          </v-container>
        </div>

        <!-- Vaciar carrito -->

        <v-row class="mt-6 mb-3">
          <v-btn @click="confirmClear = true" class="ma-2" color="red" variant="tonal" style="text-transform: none">
            <v-icon icon="mdi-delete" color="red" start></v-icon>
            Vaciar todo el carrito ({{ totalCajas }})
          </v-btn>
        </v-row>

        <!-- 🔥 Diálogo de confirmación -->
        <v-dialog v-model="confirmClear" max-width="400">
          <v-card>
            <v-card-title class="text-h6">Confirmar acción</v-card-title>

            <v-card-text>
              ¿Estás seguro de que deseas vaciar todo el carrito?
              <br />
              <strong>Se eliminarán todos los productos.</strong>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn variant="text" @click="confirmClear = false">
                Cancelar
              </v-btn>

              <v-btn color="red" variant="flat" @click="confirmClearAndClearCart">
                Sí, vaciar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Productos sugeridos -->
        <div v-if="suggestedItems.length > 0" class="mt-4">
          <v-card-subtitle class="text-center font-weight-bold text-black">
            Otros clientes también compraron
          </v-card-subtitle>

          <v-row>
            <v-col v-for="product in suggestedItems" :key="product.id" cols="6" sm="6" md="4" lg="3"
              class="flex flex-col items-center relative">
              <v-img :src="product.foto" width="80" height="80" alt="Imagen del producto" class="rounded"></v-img>

              <div class="text-caption font-weight-medium text-gray-600">
                {{ product.nombre }}
              </div>
              <!-- Precio -->
              <template v-if="product.id_promocion && product.promo_price">
                <!-- Precio original rayado -->
                <div class="text-gray-500 line-through font-semibold">
                  ${{ product.price }}
                </div>

                <!-- Precio con descuento -->
                <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                  ${{
                    (product.price - (product.price * product.promo_price) / 100).toFixed(
                      2
                    )
                  }}
                </div>
              </template>
              <template v-else>
                <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-700">
                  ${{ product.price }}
                </div>
              </template>
              <div v-if="product.id_promocion && product.promo_price"
                class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full">
                Descuento {{ product.promo_price }}%
              </div>
              <v-btn @click="addToCart(product)" class="text-none text-subtitle-1 add-to-cart-btn keep-color"
                color="white" variant="flat" :id="'add-btn-' + product.id" :style="{
                  position: 'absolute',
                  top: '15px',
                  right: '10px',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  minWidth: '40px',
                }">
                <v-icon color="blue-darken-4" size="28" class="add-icon keep-color">
                  mdi-plus-circle
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <!-- Subtotal y acción -->
      <v-card-actions class="flex flex-col">



      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script setup>
import { inject, computed, ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";

const cartDialog = ref(true);
const confirmClear = ref(false);

// Inyectar el store del carrito
const cartStore = inject("cartStore");
if (!cartStore) {
  throw new Error("cartStore no fue proporcionado");
}

// Computado del carrito con valor por defecto
const cart = computed(() => cartStore.state?.cart ?? []);

// Computado para el total de cajas
const totalCajas = computed(() => {
  return cart.value.reduce((total, item) => total + item.quantity, 0);
});

// Productos sugeridos
const suggestedItems = ref([]);

// Manejar eliminación de productos
const handleRemove = (item) => {
  if (item.comboId) {
    // Si pertenece a un combo, eliminar ambos
    cartStore.removeComboFromCart(item.comboId);
  } else {
    // Si es producto normal, eliminar solo ese
    const index = cart.value.findIndex((p) => p.sku === item.sku && p.id === item.id);
    if (index !== -1) {
      cartStore.removeFromCart(index);
    }
  }
};

// Obtener productos sugeridos desde el backend
const fetchSuggestedProducts = async () => {
  try {
    const response = await axios.get(
      "https://mvexpress.mx/api/suggested-products"
    );
    if (Array.isArray(response.data)) {
      suggestedItems.value = response.data;
    }
  } catch (err) {
    console.error("Error al obtener productos sugeridos:", err);
  }
};

// Verificar si el carrito se está actualizando correctamente
watch(cart, (newCart) => {
  console.log("Contenido actualizado del carrito:", newCart);
  const newIndex = cartStore.state.cart.length - 1;
  swipeState[newIndex] = 0;
});

// Al montar el componente
onMounted(() => {
  fetchSuggestedProducts();
  const newIndex = cartStore.state.cart.length - 1;
  swipeState[newIndex] = 0;
});

const router = useRouter();

// Agregar producto al carrito
const addToCart = (product) => {
  const currentQty = getProductQuantity(product);

  // 🔹 Limite para productos en promoción
  if (product.id_promocion && currentQty >= 1) {
    alert("Solo puedes agregar 1 unidad de este producto en promoción.");
    return;
  }

  // 🔹 Limite para productos normales según stock
  if (!product.id_promocion && currentQty >= (product.yfr_disponible || 100)) {
    alert("No hay suficiente stock disponible.");
    return;
  }

  cartStore.addToCart(product);
};

// Aumentar cantidad
const increaseQuantity = async (item) => {
  if (item.promoUnico || item.precio_con_descuento) {
    if (item.quantity >= 5) return;
  } else if (item.quantity >= 40) return;

  // Validar stock
  cartStore.increaseQuantity(item);
};

const decreaseQuantity = (item) => {
  cartStore.decreaseQuantity(item);
};

const getProductQuantity = (product) => {
  const item = cart.value.find(
    (p) => (p.id || p.producto_id) === (product.id || product.producto_id)
  );
  return item ? item.quantity || 0 : 0;
};

// Eliminar del carrito

// Vaciar carrito

// Calcular total del carrito
// Calcular total del carrito
const calculateTotal = () => {
  return cart.value
    .reduce((acc, item) => {
      if (item.sku && item.sku.startsWith("PP")) return acc;

      const basePrice = parseFloat(item.price ?? item.precio_desc ?? 0);
      let unitPrice = basePrice;

      // 👇 Si el producto tiene promoción aplica el descuento
      if (item.id_promocion && item.promo_price) {
        unitPrice = basePrice - basePrice * (item.promo_price / 100);
      } else if (item.precio_con_descuento) {
        // Si ya tiene un precio con descuento explícito, úsalo
        unitPrice = parseFloat(item.precio_con_descuento);
      }

      return acc + unitPrice * (item.quantity || 1);
    }, 0)
    .toFixed(2);
};
const confirmClearAndClearCart = () => {
  cartStore.clearCart();
  swipeState.value = {};
  confirmClear.value = false;
};

// Ir al checkout
const checkout = () => {
  const total = parseFloat(calculateTotal());

  // Guardar todo lo necesario
  localStorage.setItem("checkoutTotal", total);
  localStorage.setItem("checkoutCart", JSON.stringify(cart.value));
  localStorage.setItem("checkoutCajas", totalCajas.value);

  router.push({ path: "/metodo-pago" });
};

const startX = ref(0);
const currentIndex = ref(null);
const isSwiping = ref(false);
const swipeState = ref({});

const buttonWidth = 100;
const threshold = 40;

let lastDelta = 0;
let animationFrame = null;

// --- Inicia el toque ---
function startTouch(e, index) {
  startX.value = e.touches[0].clientX;
  currentIndex.value = index;
  isSwiping.value = true;
  cancelAnimationFrame(animationFrame);
}

// --- Mueve el swipe ---
function moveTouch(e, index) {
  if (!isSwiping.value || currentIndex.value !== index) return;

  const deltaX = e.touches[0].clientX - startX.value;
  lastDelta = Math.min(0, Math.max(-buttonWidth * 1.5, deltaX)); // límite suave

  cancelAnimationFrame(animationFrame);
  animationFrame = requestAnimationFrame(() => {
    swipeState.value[index] = lastDelta;
  });
}

// --- Termina el swipe ---
function endTouch(e, index) {
  isSwiping.value = false;
  cancelAnimationFrame(animationFrame);

  if (swipeState.value[index] < -threshold) {
    animateTo(index, -buttonWidth);

    // 🔹 Cierra después de 2 segundos si no se elimina
    setTimeout(() => {
      animateTo(index, 0);
    }, 1000);
  } else {
    animateTo(index, 0);
  }
}
// --- Animación con easing suave ---
function animateTo(index, target) {
  let start = swipeState.value[index] || 0;
  let startTime = null;
  const duration = 100; // ms

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const easeOut = 1 - Math.pow(1 - progress, 3);
    swipeState.value[index] = start + (target - start) * easeOut;

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }
  requestAnimationFrame(step);
}

// --- 🔥 Reinicia todos los swipes ---
</script>

<style scoped>
.product-name {
  word-break: break-word;
  /* rompe palabras largas */
  overflow-wrap: anywhere;
  /* fuerza que se divida si no cabe */
  white-space: normal;
  /* asegura que no se quede en una sola línea */
}

.product-info p {
  word-break: break-word;
  overflow-wrap: anywhere;
}

.swipe-container {
  position: relative;
  overflow: hidden;
  background: rgb(255, 255, 255);
  margin-bottom: 8px;
}

.delete-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.swipe-content {
  display: flex;
  width: 100%;
  transition: transform 0.25s ease;
  background: white;
  z-index: 2;
}

.wave-button {
  position: relative;
  /* ya lo tienes */
  overflow: visible;
  /* 🔹 permite que ::after sobresalga */
}

.wave-button::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s ease, height 0.6s ease, opacity 0.6s ease;
  pointer-events: none;
}

.dialog-safe {
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  margin-top: env(safe-area-inset-top);
  margin-bottom: env(safe-area-inset-bottom);
  border-radius: 0 !important;
}

.wave-button:active::after {
  width: 300px;
  height: 300px;
  opacity: 0;
}
</style>
